import React from 'react';

export type DetailTabKey = 'overview' | 'setup' | 'markets' | 'partners' | 'testing' | 'fieldwork' | 'activity' | 'samples' | 'schedule';

const LABELS: Record<DetailTabKey, string> = {
  overview: 'Overview', setup: 'Setup', markets: 'Markets', partners: 'Partners',
  testing: 'Testing', fieldwork: 'Fieldwork', activity: 'Activity', samples: 'Samples', schedule: 'Schedule',
};

// Old links: ?tab=panelLaunch was the combined Samples + Schedule tab.
export const normalizeDetailTab = (raw: string | null): DetailTabKey | null =>
  (raw === 'panelLaunch' ? 'samples' : raw) as DetailTabKey | null;

export const detailTabsFor = ({ isChild, hasPanelMarket, isSales }: { isChild: boolean; hasPanelMarket: boolean; isSales: boolean }): DetailTabKey[] => {
  // Markets is on both parent and child pages; isChild is kept for callers but no longer changes the list.
  void isChild;
  const tabs: DetailTabKey[] = ['overview', 'setup', 'markets', 'partners', 'testing', 'fieldwork'];
  if (hasPanelMarket && !isSales) tabs.push('samples', 'schedule');
  // Activity is always the last tab.
  tabs.push('activity');
  return tabs;
};

type Props = {
  tabs: DetailTabKey[];
  active: DetailTabKey;
  counts?: Partial<Record<DetailTabKey, number | string>>;
  onSelect: (k: DetailTabKey) => void;
};

export const DetailTabs: React.FC<Props> = ({ tabs, active, counts, onSelect }) => (
  <div className="dx-tabs" role="tablist">
    {tabs.map((k) => (
      <button key={k} type="button" role="tab" aria-selected={k === active}
        className={`dx-tab${k === active ? ' active' : ''}`} onClick={() => onSelect(k)}>
        {LABELS[k]}
        {counts && counts[k] !== undefined && <span className="dx-tab-count">{counts[k]}</span>}
      </button>
    ))}
  </div>
);
